export default {
  namespaced: true,
  state: {
    showProfileBanner: false
  },
  mutations: {
    setShowProfileBanner (state, show) {
      state.showProfileBanner = show
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/notifications.js